var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFomfShapeFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.714 15.82c0-4.441 3.59-8.055 8.001-8.055V0C11.05 0 4 7.097 4 15.82c0 8.724 7.05 15.82 15.715 15.82v-7.765c-4.412 0-8.001-3.613-8.001-8.055zm23.717 7.765c0 8.724-7.05 15.821-15.715 15.821v-7.765c4.412 0 8.001-3.614 8.001-8.056 0-4.441-3.59-8.054-8.002-8.054V7.765c8.666 0 15.716 7.097 15.716 15.82z"
  })));
}
export default SvgFomfShapeFill;